import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

function Order() {
  const cartItems = useSelector((state) => state.EMenu.cartItems);

  const vatRate = useSelector((state) => state.Tax.vatRate);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const hideTax = useSelector((state) => state.Tax.hideTax);
  const serviceRate = useSelector((state) => state.Tax.serviceRate);
  const stateRate = useSelector((state) => state.Tax.stateRate);
  const sumOfTax = useSelector((state)=> state.Tax.sumOfTax);


  return (
    <>
      <ul className=" min-md:p-4 overflow-hidden overflow-y-auto h-[45%] scroll-smooth mb-4">
        {cartItems?.map((item, index) => (
          <div key={index} className=" border-primaryLight/70">
            <li
              key={index}
              className={`bg-white md:w-[100%] md:m-auto md:hover:shadow-xl transition-shadow delay-75 md:border md:border-dark/10 md:hover:border-dark/0 hover:shadow-dark/10 md:p-4 max-md:p-2 flex gap-4 justify-between items-center`}
            >
              <p className="font-normal text-secondary text-left text-sm w-[50%] ">
                {item.ProductName}
              </p>
              <p className="text-sm w-[20%] text-start max-md:hidden">
                {item.Price?.toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
                <span className="text-sm max-md:hidden"> / portion</span>
              </p>
              <p className="w-[10%] text-sm text-center max-md:hidden">
                X {item.Quantity}
              </p>
              <p className="w-[20%] font-black  text-start text-base max-md:hidden">
                {Number(item.TotalPrice).toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
              </p>
            </li>
            <div className="min-md:hidden px-4 py-2 flex justify-center max-sm:mb-6">
              <p className="text-base w-[50%] text-dark/70 text-start md:hidden">
                {item.Price?.toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
                <span className="text-sm md:hidden"> / portion</span>
              </p>
              <p className="w-[10%] text-center md:hidden">X {item?.Qty}</p>
              <p className="w-[45%] text-secondary text-end font-extrabold text-xl md:hidden">
                {(Number(item?.TotalPrice)).toLocaleString("en-NG", {
                  style: "currency",
                  currency: "NGN",
                })}
              </p>
            </div>
          </div>
        ))}
      </ul>
    </>
  );
}

export default Order;
